import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, NgModule, Output, ViewChild } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { TaxRatesEditorModule } from '../../../../../core/components/tax-rates-editor/tax-rates-editor.component';

@Component({
    selector: 'edit-tax-rates',
    templateUrl: './edit-tax-rates.component.html',
    standalone: false,
})
export class EditTaxRatesComponent {
    public lockedFields: string[] = ['description', 'code', 'type'];
    @Input() modal: any;
    @Input() details: any;
    @Input() alterable = false;
    @ViewChild('taxRatesEditor', { static: true }) taxRatesEditor: any;
    @Output() action = new EventEmitter();

    constructor(private bsModalRef: BsModalRef) {}

    isValid(): boolean {
        return this.taxRatesEditor.isValid;
    }

    ok() {
        if (this.isValid()) {
            this.details.description = this.taxRatesEditor.description;
            this.details.shortCode = this.taxRatesEditor.shortCode;
            this.details.taxRates = this.taxRatesEditor.currentTaxRateEntries();
            /* Adding both conditions for old modal (jobs) and new BsModal (estimates). Old one will be deprecated after migration */
            if (this.modal) {
                this.modal.close(this.details);
            }
            if (this.bsModalRef) {
                this.bsModalRef.hide();
            }

            this.action.emit({
                cancelled: false,
                details: this.details,
            });
        }
    }

    cancel() {
        if (this.modal) {
            this.modal.dismiss('cancel');
        }
        if (this.bsModalRef) {
            this.bsModalRef.hide();
        }
        this.action.emit({ cancelled: true, details: this.details });
    }
}

@NgModule({
    imports: [CommonModule, TaxRatesEditorModule],
    declarations: [EditTaxRatesComponent],
})
export class EditTaxRatesModule {}
